import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Loading from "./../Loading/Loading";
import { getSession } from "./../../Slices/sessionSlice";
import NonAuthorized from "../NonAuthorized/NonAuthorized";
function PrivateRoute({ allowedRoles, component: Component, pageTitle }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSession());
    document.title = pageTitle + " - Tracker";
  }, [dispatch]);

  const { sessionUser } = useSelector((state) => state.sessionSlice);
  const filteredArray = allowedRoles.filter(
    (value) => sessionUser && sessionUser.roles.includes(value)
  );
  const fAuthorized = filteredArray.length !== 0;
  if (!sessionUser) {
    return (
      <>
        <Loading />
      </>
    );
  }

  if (!fAuthorized) {
    return <NonAuthorized />;
  }

  if (fAuthorized) {
    return <Component />;
  }
}

export default PrivateRoute;
